import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Button, Drawer, Menu, PageHeader, Dropdown } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { isMobileMode } from "../../modules/configuration";
import { getLocale, setLocale, IT, EN, CONTATTI, FAQ, INFORMATIVA_TRATTAMENTO_DATI, LINGUA_INGLESE, LINGUA_ITALIANA } from "../../modules/language"; //prettier-ignore
import { PATH_CONTATTI, PATH_FAQ, PATH_INFORMATIVA, PATH_HOME } from "../../path";
import { getMessageString } from "../../tools";
import { getInfoInterventoStore, resetInfoIntervento, stopPolling } from "../../modules/surgery";

const { Item } = Menu;

const MENU = "menu";
const CONTATTI_KEY = "contatti";
const FAQ_KEY = "faq";
const INFORMATIVA_KEY = "informativa";
const SWITCH_EN = "switchEn";
const SWITCH_IT = "switchIt";

const HeaderBase = ({ intl, history, backEnabled = null }) => {
  const dispatch = useDispatch();
  const [menuCollapsed, setMenuCollapsed] = useState(true);
  const locale = useSelector(getLocale);
  const mobileMode = useSelector(isMobileMode);
  const infoInterventoStore = useSelector(getInfoInterventoStore);

  useEffect(() => {
    const submenu = document.getElementsByClassName("ant-menu-submenu-title")[0];
    if (submenu && submenu !== undefined) submenu.removeAttribute("role");
  });

  const backHome = () => {
    dispatch(resetInfoIntervento());
    if (infoInterventoStore && infoInterventoStore.pollingStarted) dispatch(stopPolling());
    if (mobileMode) setMenuCollapsed(!menuCollapsed);
  };

  const LogoApp = () => (
    <Link to={PATH_HOME} onClick={backHome}>
      Surgery Tracker
    </Link>
  );

  const MobileMenu = () => (
    <>
      <Button
        onClick={() => setMenuCollapsed(!menuCollapsed)}
        icon={<MenuOutlined className="menuBarsIcon" aria-label="Sandwich button" />}
        className="mobileMenuButton"
      >
        <span style={{ display: "none" }}>Menu</span>
      </Button>
      <Drawer
        className="menuDrawer mobileDrawer"
        closable={true}
        placement="right"
        title={<LogoApp />}
        visible={!menuCollapsed}
        onClose={() => setMenuCollapsed(!menuCollapsed)}
      >
        <Menu
          onClick={(e) => {
            onOverlayMenuClick(e);
            setMenuCollapsed(!menuCollapsed);
          }}
        >
          <Item key={CONTATTI_KEY}>{getMessageString(intl, CONTATTI)}</Item>
          <Item key={FAQ_KEY}>{getMessageString(intl, FAQ)}</Item>
          <Item key={INFORMATIVA_KEY}>{getMessageString(intl, INFORMATIVA_TRATTAMENTO_DATI)}</Item>
          {locale === IT && <Item key={SWITCH_EN}>{getMessageString(intl, LINGUA_INGLESE)}</Item>}
          {locale === EN && <Item key={SWITCH_IT}>{getMessageString(intl, LINGUA_ITALIANA)}</Item>}
        </Menu>
      </Drawer>
    </>
  );

  const DropdownMenu = () => (
    <Dropdown overlay={overlayMenu} trigger={["click"]} overlayClassName="dropdownOverlay">
      <Button icon={<MenuOutlined />}>
        <span style={{ display: "none" }}>Menu</span>
      </Button>
    </Dropdown>
  );

  const onOverlayMenuClick = (e) => {
    if (e.key === CONTATTI_KEY) history.push(PATH_CONTATTI);
    if (e.key === FAQ_KEY) history.push(PATH_FAQ);
    if (e.key === INFORMATIVA_KEY) history.push(PATH_INFORMATIVA);
    if (e.key === SWITCH_EN) dispatch(setLocale({ countryCode: EN }));
    if (e.key === SWITCH_IT) dispatch(setLocale({ countryCode: IT }));
    // prettier-ignore
    if ((e.key === CONTATTI_KEY || e.key === FAQ_KEY || e.key === INFORMATIVA_KEY) && infoInterventoStore && infoInterventoStore.pollingStarted)
      dispatch(stopPolling());
  };

  const overlayMenu = (
    <Menu onClick={onOverlayMenuClick}>
      <Item key={CONTATTI_KEY}>{getMessageString(intl, CONTATTI)}</Item>
      <Item key={FAQ_KEY}>{getMessageString(intl, FAQ)}</Item>
      <Item key={INFORMATIVA_KEY}>{getMessageString(intl, INFORMATIVA_TRATTAMENTO_DATI)}</Item>
      {locale === IT && <Item key={SWITCH_EN}>{getMessageString(intl, LINGUA_INGLESE)}</Item>}
      {locale === EN && <Item key={SWITCH_IT}>{getMessageString(intl, LINGUA_ITALIANA)}</Item>}
    </Menu>
  );

  const DesktopHeader = () => (
    <PageHeader
      className="desktopHeader"
      {...(backEnabled && {
        onBack: () => {
          if (infoInterventoStore && infoInterventoStore.pollingStarted) dispatch(stopPolling());
          history.goBack();
        },
      })}
      title={<LogoApp />}
      extra={[<DropdownMenu key={MENU} />]}
    />
  );

  const MobileHeader = () => (
    <PageHeader
      className="mobileHeader"
      {...(backEnabled && {
        onBack: () => {
          if (infoInterventoStore && infoInterventoStore.pollingStarted) dispatch(stopPolling());
          history.goBack();
        },
      })}
      title={<LogoApp />}
      extra={[<MobileMenu key="mobileMenu" />]}
    />
  );

  return mobileMode ? <MobileHeader /> : <DesktopHeader />;
};
export const Header = withRouter(injectIntl(HeaderBase));
